import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { FieldErrors } from 'react-hook-form';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function smoothScrollToError(errors: FieldErrors, setCanFocus: React.Dispatch<React.SetStateAction<boolean>>) {
  // Sort inputs based on their position on the page. (the order will be based on validaton order otherwise)
  const elements = Object.keys(errors)
    .map(name => document.getElementsByName(name)[0])
    .filter(el => !!el);
  elements.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

  if (elements.length > 0) {
    const errorElement = elements[0];
    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' }); // scrollIntoView options are not supported in Safari
    errorElement.focus({ preventScroll: true });
    setCanFocus(false); // so the form doesn't suddenly jump to the next input that has error.
  }
}

export function domainExtension(url: string) {
  const urlParts = url.split('.');
  if (urlParts.length > 2) {
    return urlParts.slice(urlParts.length - 2).join('.');
  }
  return url;
}

export const getCssVariable = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();
